import { unsplash } from './brand';
import { getDestination } from './destinations';

// Replacement photos for packages whose stored image link is broken (checked Oct 2026).
// Keyed by package id; values are verified Unsplash photo ids.
const FIX = {
  'bali-004': 'photo-1566987827971-f2c40e748a54', // Kelingking, Nusa Penida
  'azerbaijan-002': 'photo-1621454450590-a9e1f60b7b6e', // Flame Towers, Baku
  'azerbaijan-003': 'photo-1689188872801-9652a9fc2307', // Baku skyline
  'srilanka-001': 'photo-1580794749460-76f97b7180d8', // Sigiriya
  'srilanka-002': 'photo-1734279135115-6d8984e08206', // Mirissa beach
  'srilanka-004': 'photo-1566296314736-6eaac1ca0cb9', // Nine Arches Bridge, Ella
  'jordan-004': 'photo-1615811648503-479d06197ff3', // Petra
  'egypt-001': 'photo-1677775766807-ff09c770da6e', // Giza pyramids
  'egypt-003': 'photo-1684100096410-fd39cdff91a3', // Nile at sunset
  'georgia-002': 'photo-1563284223-333497472e88', // Gergeti Trinity Church, Kazbegi
  'thai-003': 'photo-1599576838688-8a6c11263108', // Chiang Mai temple
  'bhutan-003': 'photo-1637550667967-9edc9f4e892a', // Tiger's Nest
  'kerala-003': 'photo-1609828913552-f9138ed9e42d', // Alleppey houseboat
  'mauritius-003': 'photo-1513415277900-a62401e19be4', // Le Morne
  'goa-004': 'photo-1623815616495-d1de0ebbd1b2', // Goa beach
  'uttarakhand-002': 'photo-1712201649803-ab1b13dae600', // Nainital lake
  'northeast-002': 'photo-1675296098616-53e3d4a1dd57', // Kaziranga rhinos
};

/** Best image for a package card/hero. */
export const packageImage = (pkg, w = 900) => {
  if (!pkg) return '';
  if (FIX[pkg.id]) return unsplash(FIX[pkg.id], w);
  return pkg.image || getDestination(pkg.destination)?.heroImage || '';
};

/** Fallback when a package photo fails to load: the destination's verified photo. */
export const packageFallback = (pkg) => getDestination(pkg?.destination)?.heroImage || '';

/** onError handler: swap to fallback once, then hide. */
export const onImgError = (fallback) => (e) => {
  const el = e.currentTarget;
  if (fallback && !el.dataset.fb) { el.dataset.fb = '1'; el.src = fallback; } else { el.style.visibility = 'hidden'; }
};
